import { Reducer } from 'redux'
import { take, put, call } from 'redux-saga/effects'
import { fetchJson } from '../../utils';
import { ADD_POLICY_DETAIL, FETCH_POLICY_VAS_DETAIL } from './action-types';

export interface ServiceItem {
  itemCode: string,
  itemName: string,
  totalTimes: number,
  usedTimes: number,
  [k: string]: any,
}

export interface PolicyDetail {
  vasCode: string,
  serviceCode: string,
  serviceName: string,
  itemList: Array<ServiceItem>,
  [k: string]: any,
}

export interface PolicyVasDetailState {
  /* k 为权益号 policyNumber */
  [k: string]: Array<PolicyDetail>,
}

export const policyVasDetail: Reducer<PolicyVasDetailState> = (state = {}, action) => {
  const { type, policyNumber, policyDetails } = action
  switch (type) {
    case ADD_POLICY_DETAIL:
      return {...state, [policyNumber]: policyDetails}
    default:
      return state
  }
}

export function * fetchPolicyVasDetail(policyNumber: number) {
  const url = '/api/api/v1/patient/policy/queryPolicyVasDetail';

  const { code = '', result: policyDetails = [] } = yield call(fetchJson, {
    type: 'get',
    url,
    data: {
      policyNo: policyNumber,//"IH1100012941656258",
    },
    isloading: true,
  })

  if (code === '0') {
    yield put({ type: ADD_POLICY_DETAIL, policyNumber, policyDetails })
  }
}

export function * policy() {
  while (true) {
    const { policyNumber } = yield take(FETCH_POLICY_VAS_DETAIL)
    yield call(fetchPolicyVasDetail, policyNumber)
  }
}
